import api from '@/api'

export default {
  getTeachingDetail (params) {
    return api({
      url: '/teaching/details',
      methods: 'GET',
      params
    })
  },
  getMatchTeachingDetail (params) {
    return api({
      url: '/teaching/detailsMatch',
      methods: 'GET',
      params
    })
  },
  getMatchTrainListCoach (params) {
    return api({
      url: '/matchEvent/pageMatchTrainListCoach',
      methods: 'GET',
      params
    })
  },
  getMatchTrainListSystem (params) {
    return api({
      url: '/matchEvent/pageMatchTrainListSystem',
      methods: 'GET',
      params
    })
  },
  getMatchTrainListOrgan (params) {
    return api({
      url: '/matchEvent/pageMatchTrainListOrgan',
      methods: 'GET',
      params
    })
  },
  getMatchTrainListPlayer (params) {
    return api({
      url: '/matchEvent/pageMatchTrainListPlayer',
      methods: 'GET',
      params
    })
  },
  getMatchTrainListYouth (params) {
    return api({
      url: '/matchEvent/pageMatchTrainListYouth',
      methods: 'GET',
      params
    })
  },
  getMatchTrainInfo (uuid) {
    return api({
      url: `/matchEvent/matchTrainInfo/${uuid}`,
      methods: 'GET'
    })
  },
  getCommentMatchInfo (params) {
    return api({
      url: '/matchEvent/commentMatchInfo',
      methods: 'GET',
      params
    })
  },
  saveMatchTrainInfo (data) {
    return api({
      url: '/matchEvent/matchTrain',
      method: 'POST',
      data
    })
  },
  saveMatchPlayerAttendance (data) {
    return api({
      url: '/matchEvent/saveMatchPlayerAttendance',
      method: 'POST',
      data
    })
  },
  infoMatchTrainingPlanCompleteStatus (params) {
    return api({
      url: '/matchEvent/infoMatchTrainingPlanCompleteStatus',
      method: 'GET',
      params
    })
  },
  matchTrainingPlanDownLoadPdf (params) {
    return api({
      url: '/matchEvent/matchTrainingPlanDownLoadPdf',
      method: 'GET',
      params
    })
  },
  matchTrainListToPlayer (params) {
    return api({
      url: '/matchEvent/matchTrainListToPlayer',
      method: 'GET',
      params
    })
  }
}
